module.exports = __webpack_public_path__ + "img/nodejs.72acb940.png";